<template>
  <branding-field
    v-bind="$attrs"
    :border="false"
    min-width="none"
    min-height="none"
  >
    <v-layout
      slot="field"
      wrap
    >
      <v-select
        v-model="selectedFont"
        :items="fonts"
        :label="label ? label : null"
        class="mt-0 pt-0"
        hide-details
      >
        <template
          slot="item"
          slot-scope="data"
        >
          <v-list-tile-content
            :style="{
              'font-size': data.item.value ? '1.25em' : null,
              'font-family': data.item.value ? data.item.value : null,
              'border-bottom':
                data.item.value === null
                  ? '1px solid rgba(0, 0, 0, 0.16)'
                  : null,
            }"
            :class="[data.item.css]"
            @mouseover="$emit('start-preview', data.item.value)"
            @mouseleave="$emit('stop-preview')"
          >
            {{ data.item.text }}
          </v-list-tile-content>
        </template>
        <template
          slot="selection"
          slot-scope="data"
        >
          <v-list-tile-content :style="{'font-family': data.item.value}">
            {{ data.item.text }}
          </v-list-tile-content>
        </template>
      </v-select>
    </v-layout>
  </branding-field>
</template>

<script>
import {default as defaultFonts} from '@/mixins/fonts.js';

import BrandingField from '@/components/BrandingField';

export default {
  components: {
    BrandingField,
  },
  inheritAttrs: false,
  props: {
    /** Specific to this field type. */
    label: {
      type: String,
      default: null,
    },
    fontName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      fonts: defaultFonts,
    };
  },
  computed: {
    selectedFont: {
      get() {
        return this.fontName;
      },
      set(fontName) {
        this.$emit('update:fontName', fontName);
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/BrandingFontfield.vue